var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        {
          staticStyle: { padding: "0px" },
          attrs: { disabled: _vm.formDisabled }
        },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              staticStyle: { padding: "0px" },
              attrs: { slot: "detail", model: _vm.model },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _vm.processModel.applicationCode.indexOf("ipsys") == -1
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language["eletronicSigned.processNo"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: "",
                                  disabled: _vm.isDisabled
                                },
                                model: {
                                  value: _vm.model.process_no,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "process_no", $$v)
                                  },
                                  expression: "model.process_no"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.processModel.applicationCode.indexOf("ipsys") == -1
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language["eletronicSigned.startTime"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol
                              }
                            },
                            [
                              _c("a-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: _vm.isDisabled,
                                  format: _vm.dateFormat,
                                  getCalendarContainer: function(node) {
                                    return node.parentNode
                                  }
                                },
                                model: {
                                  value: _vm.model.start_time_java,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "start_time_java", $$v)
                                  },
                                  expression: "model.start_time_java"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "a-tabs",
                {
                  attrs: {
                    "default-active-key": "1",
                    size: "large",
                    "tab-bar-style": {
                      marginBottom: "24px",
                      paddingLeft: "16px"
                    }
                  },
                  on: { change: _vm.changeTabs }
                },
                [
                  _c(
                    "a-tab-pane",
                    {
                      key: "1",
                      style:
                        _vm.innerFullscreen === false
                          ? "max-height: 50vh;overflow:scroll"
                          : "max-height: 66vh;overflow:scroll",
                      attrs: { loading: "true", tab: _vm.tabName }
                    },
                    [
                      _vm.processModel.applicationCode === "env_audit"
                        ? _c(
                            "div",
                            [
                              _c("a-form-model-item", {
                                attrs: {
                                  labelCol: _vm.labelCol,
                                  wrapperCol: _vm.wrapperCol
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm.processModel.applicationCode === "ipsys" &&
                  (_vm.model.task_code === "ApproveTask8" ||
                    _vm.model.task_code === "ApproveTask9") &&
                  1 == 0
                    ? _c(
                        "a-tab-pane",
                        {
                          key: "2",
                          style:
                            _vm.innerFullscreen === false
                              ? "max-height: 50vh;overflow:scroll"
                              : "max-height: 66vh;overflow:scroll",
                          attrs: {
                            tab: _vm.language["eletronicSigned.fileUrls"]
                          }
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label:
                                      _vm.language["eletronicSigned.fileUrls"],
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol
                                  }
                                },
                                [
                                  _c("j-upload", {
                                    attrs: {
                                      "upload-source": "ipsys",
                                      disabled: "",
                                      customName: true,
                                      multiple: _vm.fileAttribute.fileMultiple
                                    },
                                    on: { change: _vm.handleChange },
                                    model: {
                                      value: _vm.fileUrls,
                                      callback: function($$v) {
                                        _vm.fileUrls = $$v
                                      },
                                      expression: "fileUrls"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-tab-pane",
                    {
                      key: "3",
                      style:
                        _vm.innerFullscreen === false
                          ? "max-height: 50vh;overflow:scroll"
                          : "max-height: 66vh;overflow:scroll",
                      attrs: { tab: _vm.singTableName }
                    },
                    [
                      _c(
                        "a-card",
                        {
                          attrs: {
                            loading: _vm.loading,
                            bordered: false,
                            title: _vm.language["eletronicSigned.signList"]
                          }
                        },
                        [
                          _c("a-table", {
                            attrs: {
                              size: "middle",
                              columns: _vm.columns,
                              pagination: false,
                              dataSource: _vm.dataSource,
                              loading: _vm.loading
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "approveResult",
                                fn: function(text, record) {
                                  return _c("span", {}, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          text === "Cancel"
                                            ? _vm.language[
                                                "eletronicSigned.termination"
                                              ]
                                            : _vm.langCode === "zh_CN" ||
                                              _vm.langCode === "zh_TW"
                                            ? record.actionTextLocalLang
                                            : record.actionTextEn
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-card",
                        {
                          attrs: {
                            loading: _vm.loading,
                            bordered: false,
                            title: _vm.language["eletronicSigned.signPerson"]
                          }
                        },
                        [
                          _c("a-table", {
                            attrs: {
                              columns: _vm.approverColumns,
                              size: "middle",
                              "data-source": _vm.approverData,
                              pagination: false,
                              loading: _vm.loading
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-tab-pane",
                    {
                      key: "4",
                      style:
                        _vm.innerFullscreen === false
                          ? "max-height: 50vh;overflow:scroll"
                          : "max-height: 66vh;overflow:scroll",
                      attrs: {
                        tab: _vm.language["eletronicSigned.processChart"]
                      }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "100%" },
                        attrs: { src: _vm.getProcessChart() }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }